import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class ContractSheetsService extends GoogleSheetsBaseService {

  // No constructor is needed as the parent handles all dependencies via `inject()`

  /**
   * Gets contract labels from the 'contract' tab.
   * @returns An observable of the contract labels.
   */
  getContractLabels(): Observable<any> {
    const tabName = 'contract';
    const startCell = 'C2';
    const endCell = 'C10';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets professional services from the 'accordions' tab.
   * @returns An observable of the professional services.
   */
  getProfessionalServices(): Observable<any> {
    const tabName = 'accordions';
    const startCell = 'B2';
    const endCell = 'B30';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets which days per week from the 'accordions' tab.
   * @returns An observable of the days per week.
   */
  getWhichDaysPerWeek(): Observable<any> {
    const tabName = 'accordions';
    const startCell = 'A2';
    const endCell = 'A15';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets compensation structures from the 'accordions' tab.
   * @returns An observable of the compensation structures.
   */
  getCompensationStructure(): Observable<any> {
    const tabName = 'accordions';
    const startCell = 'C2';
    const endCell = 'C15';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets HRSA scope types from the 'grants' tab.
   * @returns An observable of the HRSA scope types.
   */
  getHrsaScopeTypes(): Observable<any> {
    const tabName = 'grants';
    const startCell = 'E2';
    const endCell = 'E20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets grant restriction types from the 'grants' tab.
   * @returns An observable of the grant restriction types.
   */
  getGrantRestrictionTypes(): Observable<any> {
    const tabName = 'grants';
    const startCell = 'C2';
    const endCell = 'C10';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets grant program numbers from the 'grants' tab.
   * @returns An observable of the grant program numbers.
   */
  getGrantProgramNumbers(): Observable<any> {
    const tabName = 'grants';
    const startCell = 'D2';
    const endCell = 'D20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets grant program keys from the 'grants' tab.
   * @returns An observable of the grant program keys.
   */
  getGrantProgramKeys(): Observable<any> {
    const tabName = 'grants';
    const startCell = 'A2';
    const endCell = 'A20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }

  /**
   * Gets a list of grant uses from the 'grants' tab.
   * @returns An observable of the grant use list.
   */
  getGrantUseList(): Observable<any> {
    const tabName = 'grants';
    const startCell = 'B2';
    const endCell = 'B20';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}